module.exports = __webpack_public_path__ + "static/img/home_productcard_pool.eee6e003.jpg";